define('drops/calendar/calendarParameter',[],function () {
    'use strict';

    return {
        convert: function (momentDate) {
            var d = new Date(Date.UTC(
                momentDate.get('year'),
                momentDate.get('month'),
                momentDate.get('date'),
                momentDate.get('hour'),
                momentDate.get('minute'),
                momentDate.get('second')));
            return d;
        }
    };
});
